import React from 'react'
import { Layout, FAQSection } from '../components/common'
import {
  MainImage,
  OverviewSection,
  IntroSection,
  StepsSet,
  LoginSection
} from '../components/NextSteps'

const NextStepsPage = ({ data = {} }) => {
  return (
    <Layout query={data} title='PGA.Coach'>
      <MainImage />
      <OverviewSection />
      <IntroSection />
      <LoginSection />
      <StepsSet />
      <LoginSection />
      <FAQSection />
    </Layout>
  )
}

export default NextStepsPage
